import { changeLocale } from '@formkit/vue'
import { watch } from 'vue'
import type { Composer } from 'vue-i18n'

export type FormkitLocale = 'de' | 'en' | 'fr' | 'it'

const FORMKIT_LOCALES = new Set<FormkitLocale>(['de', 'en', 'fr', 'it'])

export const resolveFormkitLocale = (code?: string): FormkitLocale => {
  const language = code?.slice(0, 2).toLowerCase() as FormkitLocale | undefined

  return language && FORMKIT_LOCALES.has(language) ? language : 'de'
}

export default defineNuxtPlugin((nuxtApp) => {
  const locale = (nuxtApp.$i18n as Composer).locale
  const applyLocale = (code?: string) => changeLocale(resolveFormkitLocale(code))

  applyLocale(locale.value)
  watch(locale, applyLocale)
})
